// ../base/config/index.ts
var ConfigBase = class {
  #config;
  constructor(config2) {
    this.#config = config2;
  }
  /**
   * Get a copy of the config object
   */
  get() {
    return {
      ...this.#config,
      ...JSON.parse(JSON.stringify(this.#config))
    };
  }
  /**
   * Returns a function that always gets the latest state from the config based on the given selector.
   *
   * @example
   * ```ts
   * const getSomeConfValue = config.select((conf) => {
   *   return conf.someValue;
   * });
   *
   * getSomeConfValue(); // returns `conf.someValue`
   * ```
   */
  select(selector) {
    return () => selector(this.get());
  }
  /**
   * Update configuration object by mutation
   *
   * Pass a function that receives a copy of the current config.
   * Any mutations to this copy will be applied as the new config object.
   *
   * @example
   * ```ts
   * config.set((existingConfig) => {
   *   existingConfig.someProp = 1234;
   *   existingConfig.nested.prop = 'abcd';
   * })
   * ```
   */
  set(updateConfig) {
    const configCopy = this.get();
    updateConfig(configCopy);
    Object.assign(this.#config, configCopy);
  }
};

// src/config/index.ts
var config = new ConfigBase({
  env: "dev",
  auth: {
    autoRefresh: true,
    autoRefreshTime: 30 * 60 * 1e3,
    cookies: {
      token: "jw_auth_gateway",
      mfa: {
        identifier: "jw_auth_gateway_mfa",
        ttl: 60 * 60 * 24 * 14
        // 14 days
      },
      authFromAdmin: "jw_auth_gateway_from_admin"
    }
  },
  urls: {
    apiGateway: ""
  },
  upload: {
    direct: {
      // 100 MB
      maxSize: 100 * 1e3 ** 2
    },
    multipart: {
      maxRetries: 3,
      timeBetweenRetries: 3e3,
      // 10 MB
      partSize: 10 * 1e3 ** 2,
      maxConcurrentParts: 3
    }
  }
});

export { config };
